import { render } from "./CommunityClone.vue?vue&type=template&id=4ddad0b7&scoped=true"
import script from "./CommunityClone.vue?vue&type=script&lang=js"
export * from "./CommunityClone.vue?vue&type=script&lang=js"

import "./CommunityClone.vue?vue&type=style&index=0&id=4ddad0b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddad0b7"]])

export default __exports__